import { render, staticRenderFns } from "./MainPlanTab.vue?vue&type=template&id=717622c8&scoped=true&"
import script from "./MainPlanTab.vue?vue&type=script&lang=ts&"
export * from "./MainPlanTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717622c8",
  null
  
)

export default component.exports